import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AppService } from '../services/app.service';
import { UserService } from '../services/user.service';
import { RouterService } from '../services/router/router.service';
import { isNullOrUndefined } from 'util';

@Injectable()
export class ContentGuard implements CanActivate {
    constructor(
        private appService: AppService,
        private router: Router,
        private userService: UserService,
        private routerService: RouterService
    ) { }

    canActivate(): boolean {
        if (isNullOrUndefined(this.appService.getToken())) {
            if (isNullOrUndefined(localStorage.getItem('token')) || isNullOrUndefined(sessionStorage.getItem('user'))) {
                this.router.navigate(['']);
                return true;
            } else {
                let userInfo = sessionStorage.getItem('user');
                this.userService.setUser(JSON.parse(userInfo));
                this.appService.setToken(localStorage.getItem('token'));
                this.appService.setRefreshToken(localStorage.getItem('refreshToken'));
                if (JSON.parse(userInfo).user.cambiarPassword){
                    this.router.navigate(['restorePassword']);
                    return false;
                }
                return true;
            }
        } else {
            return true;
        }
    }
}